/* tslint:disable */
/* eslint-disable */
/**
 * User Management API V2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdminUserCreateDto
 */
export interface AdminUserCreateDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateDto
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserCreateDto
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminUserDictionaryItemDto
 */
export interface AdminUserDictionaryItemDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserDictionaryItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDictionaryItemDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminUserReadDto
 */
export interface AdminUserReadDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserReadDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserReadDto
     */
    'allowedWorkflows': Array<string>;
    /**
     * 
     * @type {SignedEulaReadDto}
     * @memberof AdminUserReadDto
     */
    'signedEula'?: SignedEulaReadDto;
}
/**
 * 
 * @export
 * @interface AdminUserReadDtoPageDto
 */
export interface AdminUserReadDtoPageDto {
    /**
     * 
     * @type {Array<AdminUserReadDto>}
     * @memberof AdminUserReadDtoPageDto
     */
    'items': Array<AdminUserReadDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface AdminUserUpdateDto
 */
export interface AdminUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserUpdateDto
     */
    'permissions'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiKeyGenerate
 */
export interface ApiKeyGenerate {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGenerate
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiKeyGenerate
     */
    'whitelistedIps'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGenerate
     */
    'expiresAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiKeyReadDto
 */
export interface ApiKeyReadDto {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'sanitizedSecret': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'keyIdentity': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiKeyReadDto
     */
    'ipWhitelist': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'tenantId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'createBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'lastUsedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'lastRotatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'revokedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiKeyReadDto
     */
    'permissionScope': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'ephemeralSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'lastUsedIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'rotatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyReadDto
     */
    'revokedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface EulaCreateDto
 */
export interface EulaCreateDto {
    /**
     * 
     * @type {string}
     * @memberof EulaCreateDto
     */
    'effectiveDate': string;
    /**
     * 
     * @type {string}
     * @memberof EulaCreateDto
     */
    'base64': string;
    /**
     * 
     * @type {string}
     * @memberof EulaCreateDto
     */
    'contentType': string;
    /**
     * 
     * @type {SupportedLanguageISO6391}
     * @memberof EulaCreateDto
     */
    'language': SupportedLanguageISO6391;
}


/**
 * 
 * @export
 * @interface EulaReadDto
 */
export interface EulaReadDto {
    /**
     * 
     * @type {string}
     * @memberof EulaReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EulaReadDto
     */
    'effectiveDate': string;
    /**
     * 
     * @type {string}
     * @memberof EulaReadDto
     */
    'base64': string;
    /**
     * 
     * @type {string}
     * @memberof EulaReadDto
     */
    'contentType': string;
    /**
     * 
     * @type {SupportedLanguageISO6391}
     * @memberof EulaReadDto
     */
    'language': SupportedLanguageISO6391;
}


/**
 * 
 * @export
 * @interface GlobalUserReadDto
 */
export interface GlobalUserReadDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalUserReadDto
     */
    'isAdmin': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalUserReadDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlobalUserReadDto
     */
    'allowedWorkflows': Array<string>;
    /**
     * 
     * @type {Array<TenantIdentityReadDto>}
     * @memberof GlobalUserReadDto
     */
    'tenantIdentities': Array<TenantIdentityReadDto>;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {SignedEulaReadDto}
     * @memberof GlobalUserReadDto
     */
    'signedEula'?: SignedEulaReadDto;
    /**
     * 
     * @type {string}
     * @memberof GlobalUserReadDto
     */
    'ownerTenant'?: string | null;
}
/**
 * Valid permission suffix. Compose full permission with urn:tenant:{tenantId}:{suffix} or urn:tenant:*:{suffix}.
 * @export
 * @enum {string}
 */

export const PermissionSuffix = {
    DeviceApp: 'device-app:*',
    HardwareRead: 'hardware:read',
    HardwareWrite: 'hardware:write',
    StructureRead: 'structure:read',
    StructureWrite: 'structure:write',
    TenantRead: 'tenant:read',
    TenantWrite: 'tenant:write',
    UserRead: 'user:read',
    UserWrite: 'user:write'
} as const;

export type PermissionSuffix = typeof PermissionSuffix[keyof typeof PermissionSuffix];


/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface SignedEulaReadDto
 */
export interface SignedEulaReadDto {
    /**
     * 
     * @type {string}
     * @memberof SignedEulaReadDto
     */
    'eulaId': string;
    /**
     * 
     * @type {string}
     * @memberof SignedEulaReadDto
     */
    'signedAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SupportedLanguageISO6391 = {
    None: 'none',
    En: 'en'
} as const;

export type SupportedLanguageISO6391 = typeof SupportedLanguageISO6391[keyof typeof SupportedLanguageISO6391];


/**
 * 
 * @export
 * @interface TenantCreateDto
 */
export interface TenantCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'name': string;
    /**
     * 
     * @type {Array<VatRecordDto>}
     * @memberof TenantCreateDto
     */
    'vatRecords': Array<VatRecordDto>;
}
/**
 * 
 * @export
 * @interface TenantIdentityReadDto
 */
export interface TenantIdentityReadDto {
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'alias': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'vatNo': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'lastUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'lastUpdatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'archivedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantIdentityReadDto
     */
    'archivedBy': string;
}
/**
 * 
 * @export
 * @interface TenantReadDto
 */
export interface TenantReadDto {
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'name': string;
    /**
     * 
     * @type {Array<VatRecordDto>}
     * @memberof TenantReadDto
     */
    'vatRecords': Array<VatRecordDto>;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantReadDto
     */
    'archivedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantReadDtoPageDto
 */
export interface TenantReadDtoPageDto {
    /**
     * 
     * @type {Array<TenantReadDto>}
     * @memberof TenantReadDtoPageDto
     */
    'items': Array<TenantReadDto>;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof TenantReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface TenantUpdateDto
 */
export interface TenantUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {Array<VatRecordDto>}
     * @memberof TenantUpdateDto
     */
    'vatRecords': Array<VatRecordDto>;
}
/**
 * 
 * @export
 * @interface TenantUserCreateDto
 */
export interface TenantUserCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUserCreateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserCreateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserCreateDto
     */
    'vatNo': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantUserCreateDto
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface TenantUserDictionaryItemDto
 */
export interface TenantUserDictionaryItemDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUserDictionaryItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserDictionaryItemDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TenantUserReadDto
 */
export interface TenantUserReadDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantUserReadDto
     */
    'permissions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'vatNo': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'tenantId': string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantUserReadDto
     */
    'isGuest': boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantUserReadDto
     */
    'allowedWorkflows': Array<string>;
    /**
     * 
     * @type {SignedEulaReadDto}
     * @memberof TenantUserReadDto
     */
    'signedEula'?: SignedEulaReadDto;
}
/**
 * 
 * @export
 * @interface TenantUserReadDtoPageDto
 */
export interface TenantUserReadDtoPageDto {
    /**
     * 
     * @type {Array<TenantUserReadDto>}
     * @memberof TenantUserReadDtoPageDto
     */
    'items': Array<TenantUserReadDto>;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof TenantUserReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantUserReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantUserReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantUserReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantUserReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface TenantUserUpdateDto
 */
export interface TenantUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUserUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserUpdateDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUserUpdateDto
     */
    'vatNo'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantUserUpdateDto
     */
    'permissions'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserCreateSyncKeyDto
 */
export interface UserCreateSyncKeyDto {
    /**
     * 
     * @type {number}
     * @memberof UserCreateSyncKeyDto
     */
    'keyDurationDays': number;
}
/**
 * 
 * @export
 * @interface UserSyncKeyCreateDto
 */
export interface UserSyncKeyCreateDto {
    /**
     * 
     * @type {string}
     * @memberof UserSyncKeyCreateDto
     */
    'secret': string;
    /**
     * 
     * @type {string}
     * @memberof UserSyncKeyCreateDto
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserSyncKeyCreateDto
     */
    'issuedAt': string;
}
/**
 * 
 * @export
 * @interface VatRecordDto
 */
export interface VatRecordDto {
    /**
     * 
     * @type {string}
     * @memberof VatRecordDto
     */
    'vatNo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VatRecordDto
     */
    'name'?: string | null;
}

/**
 * AdminUserApi - axios parameter creator
 * @export
 */
export const AdminUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminArchiveV2: async (userIdpId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('adminArchiveV2', 'userIdpId', userIdpId)
            const localVarPath = `/user-management/v2/admin-users/{userIdpId}/archive`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserCreateDto} [adminUserCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateV2: async (adminUserCreateDto?: AdminUserCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/admin-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEraseV2: async (userIdpId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('adminEraseV2', 'userIdpId', userIdpId)
            const localVarPath = `/user-management/v2/admin-users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllV2: async (sortBy?: string, ascending?: boolean, id?: string, name?: string, email?: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/admin-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUserDictionaryV2: async (includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/admin-users/dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {string} userIdpId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetV2: async (userIdpId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('adminGetV2', 'userIdpId', userIdpId)
            const localVarPath = `/user-management/v2/admin-users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRestoreV2: async (userIdpId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('adminRestoreV2', 'userIdpId', userIdpId)
            const localVarPath = `/user-management/v2/admin-users/{userIdpId}/restore`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {AdminUserUpdateDto} [adminUserUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateV2: async (userIdpId: string, adminUserUpdateDto?: AdminUserUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('adminUpdateV2', 'userIdpId', userIdpId)
            const localVarPath = `/user-management/v2/admin-users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserApi - functional programming interface
 * @export
 */
export const AdminUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminArchiveV2(userIdpId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminArchiveV2(userIdpId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminArchiveV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserCreateDto} [adminUserCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateV2(adminUserCreateDto?: AdminUserCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateV2(adminUserCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminCreateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEraseV2(userIdpId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEraseV2(userIdpId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminEraseV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllV2(sortBy?: string, ascending?: boolean, id?: string, name?: string, email?: string, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetAllV2(sortBy, ascending, id, name, email, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminGetAllV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetUserDictionaryV2(includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminUserDictionaryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetUserDictionaryV2(includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminGetUserDictionaryV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {string} userIdpId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetV2(userIdpId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetV2(userIdpId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminGetV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRestoreV2(userIdpId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRestoreV2(userIdpId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminRestoreV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} userIdpId 
         * @param {AdminUserUpdateDto} [adminUserUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateV2(userIdpId: string, adminUserUpdateDto?: AdminUserUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateV2(userIdpId, adminUserUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserApi.adminUpdateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUserApi - factory interface
 * @export
 */
export const AdminUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserApiFp(configuration)
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserApiAdminArchiveV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminArchiveV2(requestParameters: AdminUserApiAdminArchiveV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminArchiveV2(requestParameters.userIdpId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserApiAdminCreateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateV2(requestParameters: AdminUserApiAdminCreateV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserReadDto> {
            return localVarFp.adminCreateV2(requestParameters.adminUserCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserApiAdminEraseV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEraseV2(requestParameters: AdminUserApiAdminEraseV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEraseV2(requestParameters.userIdpId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {AdminUserApiAdminGetAllV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllV2(requestParameters: AdminUserApiAdminGetAllV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserReadDtoPageDto> {
            return localVarFp.adminGetAllV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.id, requestParameters.name, requestParameters.email, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {AdminUserApiAdminGetUserDictionaryV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetUserDictionaryV2(requestParameters: AdminUserApiAdminGetUserDictionaryV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserDictionaryItemDto>> {
            return localVarFp.adminGetUserDictionaryV2(requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read` (global scope)
         * @param {AdminUserApiAdminGetV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetV2(requestParameters: AdminUserApiAdminGetV2Request, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserReadDto> {
            return localVarFp.adminGetV2(requestParameters.userIdpId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserApiAdminRestoreV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRestoreV2(requestParameters: AdminUserApiAdminRestoreV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRestoreV2(requestParameters.userIdpId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {AdminUserApiAdminUpdateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateV2(requestParameters: AdminUserApiAdminUpdateV2Request, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserReadDto> {
            return localVarFp.adminUpdateV2(requestParameters.userIdpId, requestParameters.adminUserUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminArchiveV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminArchiveV2Request
 */
export interface AdminUserApiAdminArchiveV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminArchiveV2
     */
    readonly userIdpId: string
}

/**
 * Request parameters for adminCreateV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminCreateV2Request
 */
export interface AdminUserApiAdminCreateV2Request {
    /**
     * 
     * @type {AdminUserCreateDto}
     * @memberof AdminUserApiAdminCreateV2
     */
    readonly adminUserCreateDto?: AdminUserCreateDto
}

/**
 * Request parameters for adminEraseV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminEraseV2Request
 */
export interface AdminUserApiAdminEraseV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminEraseV2
     */
    readonly userIdpId: string
}

/**
 * Request parameters for adminGetAllV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminGetAllV2Request
 */
export interface AdminUserApiAdminGetAllV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly email?: string

    /**
     * 
     * @type {number}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetAllV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for adminGetUserDictionaryV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminGetUserDictionaryV2Request
 */
export interface AdminUserApiAdminGetUserDictionaryV2Request {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetUserDictionaryV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for adminGetV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminGetV2Request
 */
export interface AdminUserApiAdminGetV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminGetV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminUserApiAdminGetV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for adminRestoreV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminRestoreV2Request
 */
export interface AdminUserApiAdminRestoreV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminRestoreV2
     */
    readonly userIdpId: string
}

/**
 * Request parameters for adminUpdateV2 operation in AdminUserApi.
 * @export
 * @interface AdminUserApiAdminUpdateV2Request
 */
export interface AdminUserApiAdminUpdateV2Request {
    /**
     * 
     * @type {string}
     * @memberof AdminUserApiAdminUpdateV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {AdminUserUpdateDto}
     * @memberof AdminUserApiAdminUpdateV2
     */
    readonly adminUserUpdateDto?: AdminUserUpdateDto
}

/**
 * AdminUserApi - object-oriented interface
 * @export
 * @class AdminUserApi
 * @extends {BaseAPI}
 */
export class AdminUserApi extends BaseAPI {
    /**
     * Required permissions: `user:write` (global scope)
     * @param {AdminUserApiAdminArchiveV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminArchiveV2(requestParameters: AdminUserApiAdminArchiveV2Request, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminArchiveV2(requestParameters.userIdpId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write` (global scope)
     * @param {AdminUserApiAdminCreateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminCreateV2(requestParameters: AdminUserApiAdminCreateV2Request = {}, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminCreateV2(requestParameters.adminUserCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write` (global scope)
     * @param {AdminUserApiAdminEraseV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminEraseV2(requestParameters: AdminUserApiAdminEraseV2Request, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminEraseV2(requestParameters.userIdpId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read` (global scope)
     * @param {AdminUserApiAdminGetAllV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminGetAllV2(requestParameters: AdminUserApiAdminGetAllV2Request = {}, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminGetAllV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.id, requestParameters.name, requestParameters.email, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read` (global scope)
     * @param {AdminUserApiAdminGetUserDictionaryV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminGetUserDictionaryV2(requestParameters: AdminUserApiAdminGetUserDictionaryV2Request = {}, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminGetUserDictionaryV2(requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read` (global scope)
     * @param {AdminUserApiAdminGetV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminGetV2(requestParameters: AdminUserApiAdminGetV2Request, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminGetV2(requestParameters.userIdpId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write` (global scope)
     * @param {AdminUserApiAdminRestoreV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminRestoreV2(requestParameters: AdminUserApiAdminRestoreV2Request, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminRestoreV2(requestParameters.userIdpId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write` (global scope)
     * @param {AdminUserApiAdminUpdateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserApi
     */
    public adminUpdateV2(requestParameters: AdminUserApiAdminUpdateV2Request, options?: RawAxiosRequestConfig) {
        return AdminUserApiFp(this.configuration).adminUpdateV2(requestParameters.userIdpId, requestParameters.adminUserUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApiKeyApi - axios parameter creator
 * @export
 */
export const ApiKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `tenant:write`
         * @param {string} tenantId 
         * @param {ApiKeyGenerate} [apiKeyGenerate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyGenerateV2: async (tenantId: string, apiKeyGenerate?: ApiKeyGenerate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiKeyGenerateV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/api-key`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyGenerate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:read`
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyGetAllOfTenantV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiKeyGetAllOfTenantV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/api-key`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write`
         * @param {string} apiKeyId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyRevokeV2: async (apiKeyId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('apiKeyRevokeV2', 'apiKeyId', apiKeyId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiKeyRevokeV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/api-key/{apiKeyId}/revoke`
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write`
         * @param {string} apiKeyId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyRotateV2: async (apiKeyId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('apiKeyRotateV2', 'apiKeyId', apiKeyId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiKeyRotateV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/api-key/{apiKeyId}/rotate`
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeyApi - functional programming interface
 * @export
 */
export const ApiKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `tenant:write`
         * @param {string} tenantId 
         * @param {ApiKeyGenerate} [apiKeyGenerate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeyGenerateV2(tenantId: string, apiKeyGenerate?: ApiKeyGenerate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeyGenerateV2(tenantId, apiKeyGenerate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyApi.apiKeyGenerateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:read`
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeyGetAllOfTenantV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiKeyReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeyGetAllOfTenantV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyApi.apiKeyGetAllOfTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write`
         * @param {string} apiKeyId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeyRevokeV2(apiKeyId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeyRevokeV2(apiKeyId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyApi.apiKeyRevokeV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write`
         * @param {string} apiKeyId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeyRotateV2(apiKeyId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeyRotateV2(apiKeyId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeyApi.apiKeyRotateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiKeyApi - factory interface
 * @export
 */
export const ApiKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiKeyApiFp(configuration)
    return {
        /**
         * Required permissions: `tenant:write`
         * @param {ApiKeyApiApiKeyGenerateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyGenerateV2(requestParameters: ApiKeyApiApiKeyGenerateV2Request, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyReadDto> {
            return localVarFp.apiKeyGenerateV2(requestParameters.tenantId, requestParameters.apiKeyGenerate, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:read`
         * @param {ApiKeyApiApiKeyGetAllOfTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyGetAllOfTenantV2(requestParameters: ApiKeyApiApiKeyGetAllOfTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiKeyReadDto>> {
            return localVarFp.apiKeyGetAllOfTenantV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write`
         * @param {ApiKeyApiApiKeyRevokeV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyRevokeV2(requestParameters: ApiKeyApiApiKeyRevokeV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiKeyRevokeV2(requestParameters.apiKeyId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write`
         * @param {ApiKeyApiApiKeyRotateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeyRotateV2(requestParameters: ApiKeyApiApiKeyRotateV2Request, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyReadDto> {
            return localVarFp.apiKeyRotateV2(requestParameters.apiKeyId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiKeyGenerateV2 operation in ApiKeyApi.
 * @export
 * @interface ApiKeyApiApiKeyGenerateV2Request
 */
export interface ApiKeyApiApiKeyGenerateV2Request {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyGenerateV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {ApiKeyGenerate}
     * @memberof ApiKeyApiApiKeyGenerateV2
     */
    readonly apiKeyGenerate?: ApiKeyGenerate
}

/**
 * Request parameters for apiKeyGetAllOfTenantV2 operation in ApiKeyApi.
 * @export
 * @interface ApiKeyApiApiKeyGetAllOfTenantV2Request
 */
export interface ApiKeyApiApiKeyGetAllOfTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyGetAllOfTenantV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for apiKeyRevokeV2 operation in ApiKeyApi.
 * @export
 * @interface ApiKeyApiApiKeyRevokeV2Request
 */
export interface ApiKeyApiApiKeyRevokeV2Request {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyRevokeV2
     */
    readonly apiKeyId: string

    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyRevokeV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for apiKeyRotateV2 operation in ApiKeyApi.
 * @export
 * @interface ApiKeyApiApiKeyRotateV2Request
 */
export interface ApiKeyApiApiKeyRotateV2Request {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyRotateV2
     */
    readonly apiKeyId: string

    /**
     * 
     * @type {string}
     * @memberof ApiKeyApiApiKeyRotateV2
     */
    readonly tenantId: string
}

/**
 * ApiKeyApi - object-oriented interface
 * @export
 * @class ApiKeyApi
 * @extends {BaseAPI}
 */
export class ApiKeyApi extends BaseAPI {
    /**
     * Required permissions: `tenant:write`
     * @param {ApiKeyApiApiKeyGenerateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    public apiKeyGenerateV2(requestParameters: ApiKeyApiApiKeyGenerateV2Request, options?: RawAxiosRequestConfig) {
        return ApiKeyApiFp(this.configuration).apiKeyGenerateV2(requestParameters.tenantId, requestParameters.apiKeyGenerate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:read`
     * @param {ApiKeyApiApiKeyGetAllOfTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    public apiKeyGetAllOfTenantV2(requestParameters: ApiKeyApiApiKeyGetAllOfTenantV2Request, options?: RawAxiosRequestConfig) {
        return ApiKeyApiFp(this.configuration).apiKeyGetAllOfTenantV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write`
     * @param {ApiKeyApiApiKeyRevokeV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    public apiKeyRevokeV2(requestParameters: ApiKeyApiApiKeyRevokeV2Request, options?: RawAxiosRequestConfig) {
        return ApiKeyApiFp(this.configuration).apiKeyRevokeV2(requestParameters.apiKeyId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write`
     * @param {ApiKeyApiApiKeyRotateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeyApi
     */
    public apiKeyRotateV2(requestParameters: ApiKeyApiApiKeyRotateV2Request, options?: RawAxiosRequestConfig) {
        return ApiKeyApiFp(this.configuration).apiKeyRotateV2(requestParameters.apiKeyId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EulaApi - axios parameter creator
 * @export
 */
export const EulaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {EulaCreateDto} [eulaCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewEulaV2: async (eulaCreateDto?: EulaCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/eula/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eulaCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveEulaV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/eula`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEulaV2: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEulaV2', 'id', id)
            const localVarPath = `/user-management/v2/eula/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EulaApi - functional programming interface
 * @export
 */
export const EulaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EulaApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {EulaCreateDto} [eulaCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewEulaV2(eulaCreateDto?: EulaCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EulaReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewEulaV2(eulaCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EulaApi.createNewEulaV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveEulaV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EulaReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveEulaV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EulaApi.getActiveEulaV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEulaV2(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEulaV2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EulaApi.removeEulaV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EulaApi - factory interface
 * @export
 */
export const EulaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EulaApiFp(configuration)
    return {
        /**
         * Required permissions: `user:write` (global scope)
         * @param {EulaApiCreateNewEulaV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewEulaV2(requestParameters: EulaApiCreateNewEulaV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<EulaReadDto> {
            return localVarFp.createNewEulaV2(requestParameters.eulaCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveEulaV2(options?: RawAxiosRequestConfig): AxiosPromise<EulaReadDto> {
            return localVarFp.getActiveEulaV2(options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write` (global scope)
         * @param {EulaApiRemoveEulaV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEulaV2(requestParameters: EulaApiRemoveEulaV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEulaV2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createNewEulaV2 operation in EulaApi.
 * @export
 * @interface EulaApiCreateNewEulaV2Request
 */
export interface EulaApiCreateNewEulaV2Request {
    /**
     * 
     * @type {EulaCreateDto}
     * @memberof EulaApiCreateNewEulaV2
     */
    readonly eulaCreateDto?: EulaCreateDto
}

/**
 * Request parameters for removeEulaV2 operation in EulaApi.
 * @export
 * @interface EulaApiRemoveEulaV2Request
 */
export interface EulaApiRemoveEulaV2Request {
    /**
     * 
     * @type {string}
     * @memberof EulaApiRemoveEulaV2
     */
    readonly id: string
}

/**
 * EulaApi - object-oriented interface
 * @export
 * @class EulaApi
 * @extends {BaseAPI}
 */
export class EulaApi extends BaseAPI {
    /**
     * Required permissions: `user:write` (global scope)
     * @param {EulaApiCreateNewEulaV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EulaApi
     */
    public createNewEulaV2(requestParameters: EulaApiCreateNewEulaV2Request = {}, options?: RawAxiosRequestConfig) {
        return EulaApiFp(this.configuration).createNewEulaV2(requestParameters.eulaCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EulaApi
     */
    public getActiveEulaV2(options?: RawAxiosRequestConfig) {
        return EulaApiFp(this.configuration).getActiveEulaV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write` (global scope)
     * @param {EulaApiRemoveEulaV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EulaApi
     */
    public removeEulaV2(requestParameters: EulaApiRemoveEulaV2Request, options?: RawAxiosRequestConfig) {
        return EulaApiFp(this.configuration).removeEulaV2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IdentityApi - axios parameter creator
 * @export
 */
export const IdentityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserCreateSyncKeyDto} [userCreateSyncKeyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfCreateSyncKeyV2: async (userCreateSyncKeyDto?: UserCreateSyncKeyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/identity/sync-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateSyncKeyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetAccessibleTenantsV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/identity/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetSyncKeyV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/identity/sync-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRevokeEulaV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/identity/eula/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfSignEulaV2: async (eulaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eulaId' is not null or undefined
            assertParamExists('selfSignEulaV2', 'eulaId', eulaId)
            const localVarPath = `/user-management/v2/identity/eula/{eulaId}/sign`
                .replace(`{${"eulaId"}}`, encodeURIComponent(String(eulaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentityApi - functional programming interface
 * @export
 */
export const IdentityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UserCreateSyncKeyDto} [userCreateSyncKeyDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfCreateSyncKeyV2(userCreateSyncKeyDto?: UserCreateSyncKeyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSyncKeyCreateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfCreateSyncKeyV2(userCreateSyncKeyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfCreateSyncKeyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfGetAccessibleTenantsV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfGetAccessibleTenantsV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfGetAccessibleTenantsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfGetSyncKeyV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSyncKeyCreateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfGetSyncKeyV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfGetSyncKeyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfGetV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfGetV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfGetV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfRevokeEulaV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfRevokeEulaV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfRevokeEulaV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfSignEulaV2(eulaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfSignEulaV2(eulaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.selfSignEulaV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IdentityApi - factory interface
 * @export
 */
export const IdentityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentityApiFp(configuration)
    return {
        /**
         * 
         * @param {IdentityApiSelfCreateSyncKeyV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfCreateSyncKeyV2(requestParameters: IdentityApiSelfCreateSyncKeyV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSyncKeyCreateDto> {
            return localVarFp.selfCreateSyncKeyV2(requestParameters.userCreateSyncKeyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetAccessibleTenantsV2(options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantReadDto>> {
            return localVarFp.selfGetAccessibleTenantsV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetSyncKeyV2(options?: RawAxiosRequestConfig): AxiosPromise<UserSyncKeyCreateDto> {
            return localVarFp.selfGetSyncKeyV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfGetV2(options?: RawAxiosRequestConfig): AxiosPromise<GlobalUserReadDto> {
            return localVarFp.selfGetV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfRevokeEulaV2(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.selfRevokeEulaV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IdentityApiSelfSignEulaV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfSignEulaV2(requestParameters: IdentityApiSelfSignEulaV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.selfSignEulaV2(requestParameters.eulaId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for selfCreateSyncKeyV2 operation in IdentityApi.
 * @export
 * @interface IdentityApiSelfCreateSyncKeyV2Request
 */
export interface IdentityApiSelfCreateSyncKeyV2Request {
    /**
     * 
     * @type {UserCreateSyncKeyDto}
     * @memberof IdentityApiSelfCreateSyncKeyV2
     */
    readonly userCreateSyncKeyDto?: UserCreateSyncKeyDto
}

/**
 * Request parameters for selfSignEulaV2 operation in IdentityApi.
 * @export
 * @interface IdentityApiSelfSignEulaV2Request
 */
export interface IdentityApiSelfSignEulaV2Request {
    /**
     * 
     * @type {string}
     * @memberof IdentityApiSelfSignEulaV2
     */
    readonly eulaId: string
}

/**
 * IdentityApi - object-oriented interface
 * @export
 * @class IdentityApi
 * @extends {BaseAPI}
 */
export class IdentityApi extends BaseAPI {
    /**
     * 
     * @param {IdentityApiSelfCreateSyncKeyV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfCreateSyncKeyV2(requestParameters: IdentityApiSelfCreateSyncKeyV2Request = {}, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfCreateSyncKeyV2(requestParameters.userCreateSyncKeyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfGetAccessibleTenantsV2(options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfGetAccessibleTenantsV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfGetSyncKeyV2(options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfGetSyncKeyV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfGetV2(options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfGetV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfRevokeEulaV2(options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfRevokeEulaV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IdentityApiSelfSignEulaV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    public selfSignEulaV2(requestParameters: IdentityApiSelfSignEulaV2Request, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).selfSignEulaV2(requestParameters.eulaId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenantV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveTenantV2', 'tenantId', tenantId)
            const localVarPath = `/user-management/v2/tenant/{tenantId}/archive`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantCreateDto} [tenantCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantV2: async (tenantCreateDto?: TenantCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseTenantV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseTenantV2', 'tenantId', tenantId)
            const localVarPath = `/user-management/v2/tenant/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantsV2: async (includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-management/v2/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantV2: async (tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTenantV2', 'tenantId', tenantId)
            const localVarPath = `/user-management/v2/tenant/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTenantV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreTenantV2', 'tenantId', tenantId)
            const localVarPath = `/user-management/v2/tenant/{tenantId}/restore`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {TenantUpdateDto} [tenantUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantV2: async (tenantId: string, tenantUpdateDto?: TenantUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateTenantV2', 'tenantId', tenantId)
            const localVarPath = `/user-management/v2/tenant/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTenantV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTenantV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.archiveTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantCreateDto} [tenantCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTenantV2(tenantCreateDto?: TenantCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTenantV2(tenantCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.createTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseTenantV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseTenantV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.eraseTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTenantsV2(includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTenantsV2(includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.getAllTenantsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantV2(tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantV2(tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.getTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreTenantV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreTenantV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.restoreTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {string} tenantId 
         * @param {TenantUpdateDto} [tenantUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenantV2(tenantId: string, tenantUpdateDto?: TenantUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenantV2(tenantId, tenantUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantApi.updateTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantApiArchiveTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenantV2(requestParameters: TenantApiArchiveTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveTenantV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantApiCreateTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantV2(requestParameters: TenantApiCreateTenantV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<TenantReadDto> {
            return localVarFp.createTenantV2(requestParameters.tenantCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantApiEraseTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseTenantV2(requestParameters: TenantApiEraseTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.eraseTenantV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {TenantApiGetAllTenantsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantsV2(requestParameters: TenantApiGetAllTenantsV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<TenantReadDtoPageDto> {
            return localVarFp.getAllTenantsV2(requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:read` (global scope)
         * @param {TenantApiGetTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantV2(requestParameters: TenantApiGetTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantReadDto> {
            return localVarFp.getTenantV2(requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantApiRestoreTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTenantV2(requestParameters: TenantApiRestoreTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreTenantV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `tenant:write` (global scope)
         * @param {TenantApiUpdateTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantV2(requestParameters: TenantApiUpdateTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantReadDto> {
            return localVarFp.updateTenantV2(requestParameters.tenantId, requestParameters.tenantUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiArchiveTenantV2Request
 */
export interface TenantApiArchiveTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantApiArchiveTenantV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for createTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiCreateTenantV2Request
 */
export interface TenantApiCreateTenantV2Request {
    /**
     * 
     * @type {TenantCreateDto}
     * @memberof TenantApiCreateTenantV2
     */
    readonly tenantCreateDto?: TenantCreateDto
}

/**
 * Request parameters for eraseTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiEraseTenantV2Request
 */
export interface TenantApiEraseTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantApiEraseTenantV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllTenantsV2 operation in TenantApi.
 * @export
 * @interface TenantApiGetAllTenantsV2Request
 */
export interface TenantApiGetAllTenantsV2Request {
    /**
     * 
     * @type {boolean}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantApiGetAllTenantsV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for getTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiGetTenantV2Request
 */
export interface TenantApiGetTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantApiGetTenantV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TenantApiGetTenantV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for restoreTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiRestoreTenantV2Request
 */
export interface TenantApiRestoreTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantApiRestoreTenantV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for updateTenantV2 operation in TenantApi.
 * @export
 * @interface TenantApiUpdateTenantV2Request
 */
export interface TenantApiUpdateTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantApiUpdateTenantV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {TenantUpdateDto}
     * @memberof TenantApiUpdateTenantV2
     */
    readonly tenantUpdateDto?: TenantUpdateDto
}

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * Required permissions: `tenant:write` (global scope)
     * @param {TenantApiArchiveTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public archiveTenantV2(requestParameters: TenantApiArchiveTenantV2Request, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).archiveTenantV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write` (global scope)
     * @param {TenantApiCreateTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public createTenantV2(requestParameters: TenantApiCreateTenantV2Request = {}, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).createTenantV2(requestParameters.tenantCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write` (global scope)
     * @param {TenantApiEraseTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public eraseTenantV2(requestParameters: TenantApiEraseTenantV2Request, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).eraseTenantV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:read` (global scope)
     * @param {TenantApiGetAllTenantsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public getAllTenantsV2(requestParameters: TenantApiGetAllTenantsV2Request = {}, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).getAllTenantsV2(requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:read` (global scope)
     * @param {TenantApiGetTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public getTenantV2(requestParameters: TenantApiGetTenantV2Request, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).getTenantV2(requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write` (global scope)
     * @param {TenantApiRestoreTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public restoreTenantV2(requestParameters: TenantApiRestoreTenantV2Request, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).restoreTenantV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `tenant:write` (global scope)
     * @param {TenantApiUpdateTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public updateTenantV2(requestParameters: TenantApiUpdateTenantV2Request, options?: RawAxiosRequestConfig) {
        return TenantApiFp(this.configuration).updateTenantV2(requestParameters.tenantId, requestParameters.tenantUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantUserApi - axios parameter creator
 * @export
 */
export const TenantUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordV2: async (userIdpId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('resetPasswordV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('resetPasswordV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}/reset-password`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserArchiveV2: async (userIdpId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('tenantUserArchiveV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserArchiveV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}/archive`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write`
         * @param {string} tenantId 
         * @param {TenantUserCreateDto} [tenantUserCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserCreateV2: async (tenantId: string, tenantUserCreateDto?: TenantUserCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserCreateV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantUserCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserEraseV2: async (userIdpId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('tenantUserEraseV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserEraseV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {object} [filter] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserGetAllV2: async (tenantId: string, sortBy?: string, ascending?: boolean, filter?: object, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserGetAllV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (filter !== undefined) {
                for (const [key, value] of Object.entries(filter)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserGetV2: async (userIdpId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('tenantUserGetV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserGetV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserRestoreV2: async (userIdpId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('tenantUserRestoreV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserRestoreV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}/restore`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {TenantUserUpdateDto} [tenantUserUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserUpdateV2: async (userIdpId: string, tenantId: string, tenantUserUpdateDto?: TenantUserUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdpId' is not null or undefined
            assertParamExists('tenantUserUpdateV2', 'userIdpId', userIdpId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserUpdateV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/{userIdpId}`
                .replace(`{${"userIdpId"}}`, encodeURIComponent(String(userIdpId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantUserUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserUserNameResolveV2: async (tenantId: string, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantUserUserNameResolveV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/dictionary`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNameResolveV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('userNameResolveV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/user-management/v2/users/name-resolver`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantUserApi - functional programming interface
 * @export
 */
export const TenantUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantUserApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordV2(userIdpId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordV2(userIdpId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.resetPasswordV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserArchiveV2(userIdpId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserArchiveV2(userIdpId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserArchiveV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write`
         * @param {string} tenantId 
         * @param {TenantUserCreateDto} [tenantUserCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserCreateV2(tenantId: string, tenantUserCreateDto?: TenantUserCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserCreateV2(tenantId, tenantUserCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserCreateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserEraseV2(userIdpId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserEraseV2(userIdpId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserEraseV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {object} [filter] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserGetAllV2(tenantId: string, sortBy?: string, ascending?: boolean, filter?: object, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantUserReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserGetAllV2(tenantId, sortBy, ascending, filter, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserGetAllV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserGetV2(userIdpId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserGetV2(userIdpId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserGetV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserRestoreV2(userIdpId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserRestoreV2(userIdpId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserRestoreV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:write`
         * @param {string} userIdpId 
         * @param {string} tenantId 
         * @param {TenantUserUpdateDto} [tenantUserUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserUpdateV2(userIdpId: string, tenantId: string, tenantUserUpdateDto?: TenantUserUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantUserReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserUpdateV2(userIdpId, tenantId, tenantUserUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserUpdateV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantUserUserNameResolveV2(tenantId: string, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantUserDictionaryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantUserUserNameResolveV2(tenantId, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.tenantUserUserNameResolveV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `user:read`
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNameResolveV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantUserDictionaryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNameResolveV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantUserApi.userNameResolveV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantUserApi - factory interface
 * @export
 */
export const TenantUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantUserApiFp(configuration)
    return {
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiResetPasswordV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordV2(requestParameters: TenantUserApiResetPasswordV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPasswordV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiTenantUserArchiveV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserArchiveV2(requestParameters: TenantUserApiTenantUserArchiveV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tenantUserArchiveV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiTenantUserCreateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserCreateV2(requestParameters: TenantUserApiTenantUserCreateV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantUserReadDto> {
            return localVarFp.tenantUserCreateV2(requestParameters.tenantId, requestParameters.tenantUserCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiTenantUserEraseV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserEraseV2(requestParameters: TenantUserApiTenantUserEraseV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tenantUserEraseV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read`
         * @param {TenantUserApiTenantUserGetAllV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserGetAllV2(requestParameters: TenantUserApiTenantUserGetAllV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantUserReadDtoPageDto> {
            return localVarFp.tenantUserGetAllV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.filter, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read`
         * @param {TenantUserApiTenantUserGetV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserGetV2(requestParameters: TenantUserApiTenantUserGetV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantUserReadDto> {
            return localVarFp.tenantUserGetV2(requestParameters.userIdpId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiTenantUserRestoreV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserRestoreV2(requestParameters: TenantUserApiTenantUserRestoreV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tenantUserRestoreV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:write`
         * @param {TenantUserApiTenantUserUpdateV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserUpdateV2(requestParameters: TenantUserApiTenantUserUpdateV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TenantUserReadDto> {
            return localVarFp.tenantUserUpdateV2(requestParameters.userIdpId, requestParameters.tenantId, requestParameters.tenantUserUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read`
         * @param {TenantUserApiTenantUserUserNameResolveV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantUserUserNameResolveV2(requestParameters: TenantUserApiTenantUserUserNameResolveV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantUserDictionaryItemDto>> {
            return localVarFp.tenantUserUserNameResolveV2(requestParameters.tenantId, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `user:read`
         * @param {TenantUserApiUserNameResolveV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNameResolveV2(requestParameters: TenantUserApiUserNameResolveV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<TenantUserDictionaryItemDto>> {
            return localVarFp.userNameResolveV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for resetPasswordV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiResetPasswordV2Request
 */
export interface TenantUserApiResetPasswordV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiResetPasswordV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiResetPasswordV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for tenantUserArchiveV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserArchiveV2Request
 */
export interface TenantUserApiTenantUserArchiveV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserArchiveV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserArchiveV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for tenantUserCreateV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserCreateV2Request
 */
export interface TenantUserApiTenantUserCreateV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserCreateV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {TenantUserCreateDto}
     * @memberof TenantUserApiTenantUserCreateV2
     */
    readonly tenantUserCreateDto?: TenantUserCreateDto
}

/**
 * Request parameters for tenantUserEraseV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserEraseV2Request
 */
export interface TenantUserApiTenantUserEraseV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserEraseV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserEraseV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for tenantUserGetAllV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserGetAllV2Request
 */
export interface TenantUserApiTenantUserGetAllV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {object}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly filter?: object

    /**
     * 
     * @type {number}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetAllV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for tenantUserGetV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserGetV2Request
 */
export interface TenantUserApiTenantUserGetV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserGetV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserGetV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for tenantUserRestoreV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserRestoreV2Request
 */
export interface TenantUserApiTenantUserRestoreV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserRestoreV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserRestoreV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for tenantUserUpdateV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserUpdateV2Request
 */
export interface TenantUserApiTenantUserUpdateV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUpdateV2
     */
    readonly userIdpId: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUpdateV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {TenantUserUpdateDto}
     * @memberof TenantUserApiTenantUserUpdateV2
     */
    readonly tenantUserUpdateDto?: TenantUserUpdateDto
}

/**
 * Request parameters for tenantUserUserNameResolveV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiTenantUserUserNameResolveV2Request
 */
export interface TenantUserApiTenantUserUserNameResolveV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof TenantUserApiTenantUserUserNameResolveV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for userNameResolveV2 operation in TenantUserApi.
 * @export
 * @interface TenantUserApiUserNameResolveV2Request
 */
export interface TenantUserApiUserNameResolveV2Request {
    /**
     * 
     * @type {string}
     * @memberof TenantUserApiUserNameResolveV2
     */
    readonly tenantId: string
}

/**
 * TenantUserApi - object-oriented interface
 * @export
 * @class TenantUserApi
 * @extends {BaseAPI}
 */
export class TenantUserApi extends BaseAPI {
    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiResetPasswordV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public resetPasswordV2(requestParameters: TenantUserApiResetPasswordV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).resetPasswordV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiTenantUserArchiveV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserArchiveV2(requestParameters: TenantUserApiTenantUserArchiveV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserArchiveV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiTenantUserCreateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserCreateV2(requestParameters: TenantUserApiTenantUserCreateV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserCreateV2(requestParameters.tenantId, requestParameters.tenantUserCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiTenantUserEraseV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserEraseV2(requestParameters: TenantUserApiTenantUserEraseV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserEraseV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read`
     * @param {TenantUserApiTenantUserGetAllV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserGetAllV2(requestParameters: TenantUserApiTenantUserGetAllV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserGetAllV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.filter, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read`
     * @param {TenantUserApiTenantUserGetV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserGetV2(requestParameters: TenantUserApiTenantUserGetV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserGetV2(requestParameters.userIdpId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiTenantUserRestoreV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserRestoreV2(requestParameters: TenantUserApiTenantUserRestoreV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserRestoreV2(requestParameters.userIdpId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:write`
     * @param {TenantUserApiTenantUserUpdateV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserUpdateV2(requestParameters: TenantUserApiTenantUserUpdateV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserUpdateV2(requestParameters.userIdpId, requestParameters.tenantId, requestParameters.tenantUserUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read`
     * @param {TenantUserApiTenantUserUserNameResolveV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public tenantUserUserNameResolveV2(requestParameters: TenantUserApiTenantUserUserNameResolveV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).tenantUserUserNameResolveV2(requestParameters.tenantId, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `user:read`
     * @param {TenantUserApiUserNameResolveV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantUserApi
     */
    public userNameResolveV2(requestParameters: TenantUserApiUserNameResolveV2Request, options?: RawAxiosRequestConfig) {
        return TenantUserApiFp(this.configuration).userNameResolveV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}



